import type { AxiosInstance } from 'axios';
import type { DriversRegistryResponse } from '../types/driversRegistry';

export const driversRegistryQuery = async (axiosInstance: AxiosInstance) => {
	const response = await axiosInstance.get<DriversRegistryResponse>(
		'/api/v1/nahledyudaju?zdrojUdaju=REGISTR_RIDICU_V2'
	);
	return response.data;
};
